import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { UsersService } from '../../service';
@Component({

    selector: 'app-find-user',
    templateUrl: './find-user.component.html'

})

export class FindUserComponent {
    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private usersService: UsersService
    ) { }
    checkoutForm = this.formBuilder.group({
        id: '',
        phone: '',
        email: ''

    });


    onSubmit(): void {


        if (this.checkoutForm.value.id != '') {
            try {
                this.router.navigate([`users/${this.checkoutForm.value.id}`]);
                this.checkoutForm.reset();
            }
            catch (e) {
                alert(e);
            }
        }
        if (this.checkoutForm.value.phone != '') {
            try {
                this.router.navigate([`users/${this.usersService.getUserPhone(this.checkoutForm.value.phone)}`]);
                this.checkoutForm.reset();
            }
            catch (e) {
                alert(e);
            }

        }
        if (this.checkoutForm.value.email != '') {
            try {
                this.router.navigate([`users/${this.usersService.getUserEmail(this.checkoutForm.value.email)}`]);
                this.checkoutForm.reset();
            }
            catch (e) {
                alert(e);
            }

        }

    }


}



function getUserPhone(phone: any) {
    throw new Error('Function not implemented.');
}

